// src/components/Footer.jsx
import '../App.css';
import React from 'react';
import { Link } from 'react-router-dom';
import ROUTES from '../routes.json';
import { normalizeRoute } from '../utils/routeHelpers';

const Footer = () => {
    return (
        <footer className="bg-gradient-to-r from-indigo-900 via-indigo-800 to-indigo-700 mt-16 py-8 border-t border-indigo-600 shadow-lg">
            <div className="container mx-auto px-4 text-center text-gray-200 text-sm max-w-4xl">
                <p className="font-semibold tracking-wide text-lg">© 2025 OneHub AI. All rights reserved.</p>
                <p className="mt-2">
                    <Link to={normalizeRoute(ROUTES.privacy.path)} className="text-indigo-200 hover:underline">Privacy Policy</Link>{' '}|{' '}
                    <Link to={normalizeRoute(ROUTES.terms.path)} className="text-indigo-200 hover:underline">Terms of Service</Link>{' '}|{' '}
                    <Link to={normalizeRoute(ROUTES.refund.path)} className="text-indigo-200 hover:underline">Refund Policy</Link>{' '}|{' '}
                    <Link to={normalizeRoute(ROUTES.payment.path)} className="text-indigo-200 hover:underline">Payment Policy</Link>
                </p>
                <div className="mt-4">
                    <strong>Quick links:</strong>
                    <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap', marginTop: 8 }}>
                        <Link to={normalizeRoute(ROUTES.humanizer.path)} className="text-indigo-200 hover:underline">Humanizer</Link>
                        <Link to={normalizeRoute(ROUTES.blogBuilder.path)} className="text-indigo-200 hover:underline">Blog Builder</Link>
                        <Link to={normalizeRoute(ROUTES.blog.path)} className="text-indigo-200 hover:underline">Blog</Link>
                        <Link to={normalizeRoute(ROUTES.aiNews.path)} className="text-indigo-200 hover:underline">AI News</Link>
                        <Link to={normalizeRoute(ROUTES.tagGenerator.path)} className="text-indigo-200 hover:underline">Meta Tag Generator</Link>
                        <Link to={normalizeRoute(ROUTES.contact.path)} className="text-indigo-200 hover:underline">Contact</Link>
                        <Link to={normalizeRoute(ROUTES.about.path)} className="text-indigo-200 hover:underline">About</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;